<div id="revision-popup" class="common-company-popup popup-md">
    <form class="form" role="form" autocomplete="off" [formGroup]="revisionForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Revisión</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap w20">
                    <mat-label aria-label="" class="label">Fecha</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="picker" formControlName="Fecha">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="revisionForm.get('Fecha').invalid && revisionForm.get('Fecha').touched">
                        <span *ngIf="revisionForm.get('Fecha').hasError('required')">La fecha es obligatoria</span>
                    </mat-error>
                </div>
                <div class="form-wrap w40">
                    <mat-label aria-label="" class="label">Coordinador</mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="Coordinador">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="let coordinator of coordinatorList" [value]="coordinator.viewValue">
                                {{ coordinator.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap">
                    <mat-label aria-label="" class="label">Comentarios</mat-label>
                    <mat-form-field appearance="fill">
                        <textarea matInput placeholder="" rows="4" formControlName="Comentarios" maxlength="250"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>